import { create } from "zustand";
import { persist } from "zustand/middleware";
export const useLanguageStore = create(
  persist(
    (set) => ({
      language: "en",
      direction: "ltr",

      toggleLanguage: () =>
        set((state) => {
          const newLang = state.language === "en" ? "fa" : "en";
          const newDir = newLang === "fa" ? "rtl" : "ltr";
          // document.body.dir = newDir;
          // document.body.lang = newLang;
          return { language: newLang, direction: newDir };
        }),
    }),
    {
      name: "language",
    }
  )
);
